<template>
  <div class="page-case-details h-100" v-if="nod">
    <div class="case-item d-block position-relative">
      <div class="position-absolute bottom-0 end-0 px-3 py-2 blink" v-if="
        user &&
        Helper.jkrRoles.includes(user.role) &&
        nod.nod_bq &&
        !nod.nod_bq.isRead
      ">
        <i class="fa-solid fa-circle text-info" />
      </div>
      <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mb-3 mb-sm-0">
        <div class="flex-shrink-0">
          <div class="case-image bg-light" v-if="Helper.getCaseImage(nod.photos)">
            <img :src="Helper.getCaseImage(nod.photos)" class="clickable" @click="openMediaPreview(nod.photos)" />
          </div>
        </div>
        <div class="flex-grow-1 ms-sm-3">
          <p class="fw-bold mb-0 text-secondary">
            <span># {{ nod.serialNo }}</span>
          </p>
          <p class="fw-bold mb-0">
            {{ nod.typeOfDefect }}
          </p>
          <div class="pt-2 pb-3">
            <case-status-badge :case-status="nod.componentStatus" :group-type="nod.groupType" class="me-3" />
            <span class="badge bg-light text-dark px-3" v-if="nod.groupType">
              {{ nod.groupType == 'KJP' ? 'NOD' : nod.groupType }}
            </span>
          </div>
          <p class="small mb-0">
            {{ Helper.formatDate(nod.timestamp, false) }}
          </p>
          <p class="small mb-0">
            {{ `${nod.road ? getRoadName(nod.road) + ", " : ""}` }}
            {{ `${nod.district ? getDistrictName(nod.district) : ""}` }}
          </p>
          <p class="small mb-0 fs-6 fw-bold" v-if="nod.lat && nod.lng">
            {{ Helper.formatCoordinate([nod.lat, nod.lng]) }}
          </p>
          <p class="small mb-0 fs-6 fw-bold" v-if="nod.cases && nod.cases.length">
            <button class="btn btn-link px-0" @click="showCases = !showCases">
              {{ showCases ? "Hide" : "View" }} {{ nod.cases.length }} related
              case
            </button>
          </p>
        </div>

        <div class="flex-shrink-0 flex-grow-0 align-self-start ms-sm-3 mt-3 mt-sm-0 ms-auto">
          <button class="btn btn-sm btn-info" @click="editCase()">
            <i class="fas fa-pen-to-square me-2" />
            Edit Details
          </button>
        </div>
      </div>

      <div class="dropdown-divider mt-4 mb-3" v-if="showCases"></div>
      <div class="w-100 d-flex mt-2 flex-wrap gap-2" v-if="showCases">
        <div style="min-width: 40%" v-for="(c, i) in nod.cases" :key="i">
          <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center border rounded p-2">
            <div class="flex-shrink-0">
              <div class="case-image bg-light">
                <img :src="Helper.getCaseImage(c.media)" v-if="Helper.getCaseImage(c.media)" class="clickable"
                  @click="openMediaPreview(Helper.getCaseImage(c.media))" />
              </div>
            </div>
            <div class="flex-grow-1 ms-sm-3">
              <p class="fw-bold mb-0 text-secondary">
                <span>CASE # {{ c.caseNumber }}</span>
              </p>
              <p class="fw-bold mb-0">
                <span class="me-3">{{ c.caption }}</span>
              </p>
              <p class="small mb-0">
                {{ Helper.formatDate(c.timestamp, true) }}
              </p>
              <p class="small mb-0">
                {{ `${c.road ? c.road.name + ", " : ""}` }}
                {{ `${c.district ? c.district.name : ""}` }}
              </p>
              <p class="small mb-0">
                {{ Helper.formatCoordinate([c.lat, c.lng]) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overflow-hidden w-100 py-3">
      <button class="btn btn-sm rounded-3 me-3 my-1" :class="currentTab == tab.name
        ? 'btn-primary text-white'
        : 'fw-bold text-light border-0'
        " v-for="(tab, tabIndex) in computedNavTabs" :key="`navTab-${tab.name}`" :disabled="tab.enableAfter &&
          (!nod.componentStatus ||
            (nod.componentStatus &&
              nod.componentStatus[tab.enableAfter] !== true))
          " @click="currentTab = tab.name">
        {{ tabIndex + 1 }}.&nbsp;{{ tab.title }}
        <i v-if="tabIsCompleted(tab.name)" class="fa-solid fa-check-circle ms-2"
          :class="currentTab == tab.name ? 'text-white' : 'text-success'" />
      </button>
    </div>
    <div class="dropdown-divider mt-0"></div>
    <component v-if="currentTab" :is="currentTab" :component-id="currentComponentId" :nod-id="nod?.id" :nod-data="nod"
      :nod-status="nod.componentStatus || {}" :group-type="nod.groupType" :user-role="user && user.role"
      :extend-signal="extendSignal" @open-media-preview="openMediaPreview" @componentIsCompleted="getNod"
      @extend-work-order="extendWorkOrder" @extend-consumed="extendSignal = 0" />
    <div v-else class="text-center fst-italic p-3">Component not found</div>
    <media-viewer :url="currentMedia" v-if="currentMedia" @close="currentMedia = null" />
    <edit-case-modal :show="showEditCaseModal" :nod-case="nod" @close="closeEditCaseModal" />
  </div>
  <div class="case-item justify-content-center text-secondary fst-italic" v-else>
    Invalid case
  </div>
</template>

<script>
import EditCaseModal from "@/components/EditCaseModal";
import CaseStatusBadge from "@/components/CaseStatusBadge";
import MediaViewer from "@/components/MediaViewer";
import SiteVisitList from "@/views/CaseDetails/SiteVisit";
import BqList from "@/views/CaseDetails/Bq";
import PendingJkrWo from "@/views/CaseDetails/PendingJkrWo";
import PendingWo from "@/views/CaseDetails/PendingWo";
import PendingSiteDiary from "@/views/CaseDetails/PendingSiteDiary";
import PendingClaim from "@/views/CaseDetails/PendingClaim";
import PendingMemo from "@/views/CaseDetails/PendingMemo";

export default {
  components: {
    CaseStatusBadge,
    MediaViewer,
    SiteVisitList,
    BqList,
    PendingJkrWo,
    PendingWo,
    PendingSiteDiary,
    PendingClaim,
    PendingMemo,
    EditCaseModal,
  },
  data() {
    return {
      allDistricts: [],
      allRoads: [],
      user: null,
      showCases: false,
      showEditCaseModal: false,
      nod: null,
      currentMedia: null,
      navTabs: [
        {
          id: "site_visit",
          name: "site-visit-list",
          title: "Site Visit",
          collectionName: "nod_site_visit",
          statusName: "site_visit",
        },
        {
          id: "bq",
          name: "bq-list",
          title: "BQ",
          collectionName: "nod_bq",
          statusName: "bq",
          enableAfter: "site_visit",
        },
        {
          id: "jkr_wo",
          name: "pending-jkr-wo",
          title: "JKR Work Order",
          collectionName: "nod_jkr_ak",
          statusName: "jkr_wo",
          showWhenTypeIs: ["kjp"],
          enableAfter: "bq",
        },
        {
          id: "wo",
          name: "pending-wo",
          title: "Work Order",
          collectionName: "nod_wo",
          statusName: "wo",
          showWhenTypeIs: ["kjp"],
          hideWhenRoleIs: this.Helper.jkrRoles,
          enableAfter: "bq",
          // INFS-1423: the flow now runs JKR Work Order -> Site Diary
          // directly. This step only ever captured a contractor and a PDF
          // that nothing downstream reads, and it owns no dates — the
          // working period lives on nod_jkr_ak. Kept rather than deleted so
          // restoring the step is just removing this flag (the backend still
          // creates and date-syncs a paired nod-wo per JKR work order).
          hidden: true,
        },
        {
          id: "site_diary",
          name: "pending-site-diary",
          title: "Site Diary",
          collectionName: "nod_site_diary",
          statusName: "site_diary",
          showWhenTypeIs: ["kjp"],
          enableAfter: "bq",
        },
        {
          id: "claim",
          name: "pending-claim",
          title: "Claim",
          collectionName: "nod_claim",
          statusName: "claim",
          showWhenTypeIs: ["kjp"],
          enableAfter: "bq",
        },
        {
          id: "memo",
          name: "pending-memo",
          title: "Memo",
          collectionName: "nod_memo",
          statusName: "memo",
          showWhenTypeIs: ["kjp"],
          enableAfter: "bq",
        },
        {
          id: "memo",
          name: "pending-memo",
          title: "Memo",
          collectionName: "nod_memo",
          statusName: "memo",
          showWhenTypeIs: ["electrical", "emergency"],
        },
      ],
      currentTab: null,
      extendSignal: 0,
    };
  },
  computed: {
    computedNavTabs() {
      let _navTabs = JSON.parse(JSON.stringify(this.navTabs));

      const groupType = this.nod.groupType?.toLowerCase();

      return _navTabs.filter(
        (tab) =>
          !tab.hidden &&
          (!tab.showWhenTypeIs || tab.showWhenTypeIs.includes(groupType)) &&
          (!tab.hideWhenRoleIs?.length ||
            !tab.hideWhenRoleIs?.includes(this.user?.role))
      );
    },
    currentComponentId() {
      const activeTabIndex = this.navTabs.findIndex(
        (tab) => tab.name == this.currentTab
      );

      return this.nod && this.nod[this.navTabs[activeTabIndex].collectionName]
        ? this.nod[this.navTabs[activeTabIndex].collectionName].id ||
        this.nod[this.navTabs[activeTabIndex].collectionName]
        : null;
    },
    tabIsCompleted() {
      return (tabName) => {
        const tabObject = this.navTabs.find((tab) => tab.name == tabName);

        if (!tabObject) return false;

        if (["site-visit-list", "pending-site-diary"].includes(tabName)) {
          return (
            this.nod.componentStatus &&
            this.nod.componentStatus[tabObject.statusName] === true
          );
        }

        return (
          this.nod.componentStatus && this.nod.componentStatus[tabObject.id]
        );
      };
    },
  },
  methods: {
    // Site Diary's "Extend Work Order" button: jump to the JKR Work Order tab
    // and signal it to open a fresh uploadable entry.
    extendWorkOrder() {
      this.currentTab = "pending-jkr-wo";
      this.extendSignal++;
    },
    getDistrictName(id) {
      return this.allDistricts.find((district) => district.id == id)?.name;
    },
    getRoadName(id) {
      return this.allRoads.find((road) => road.id == id)?.name;
    },
    async getDistricts() {
      this.Helper.toggleLoadingSpinner(true);

      this.allDistricts = [];
      this.allRoads = [];

      const [call, error] = await this.Helper.handlePromise(
        this.API.get(this.API.endpoints().allDistricts)
      );

      if (error) {
        console.error(error);
      } else {
        this.allDistricts = call.data;

        const _allRoads = [];

        call.data.forEach((district) => {
          _allRoads.push(district.roads);
        });

        this.allRoads = _allRoads.flat();
      }

      return;
    },
    closeEditCaseModal(e) {
      this.showEditCaseModal = false;

      if (e) {
        this.getNod();
      }
    },
    editCase() {
      this.showEditCaseModal = true;
    },
    openMediaPreview(media) {
      if (!media || media.length == 0) return;

      this.currentMedia =
        typeof media == "object" ? this.Helper.getCaseImage(media) : media;
    },
    getNod() {
      this.Helper.toggleLoadingSpinner(true);

      return new Promise(async (resolve, reject) => {
        let url = `nod-cases/${this.$route.params.id}`;

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(url)
        );

        if (error) {
          console.error(error);

          reject(error);
        } else {
          this.nod = call.data;

          resolve();
        }

        this.Helper.toggleLoadingSpinner(false);
      });
    },
  },
  async mounted() {
    const _user = localStorage.getItem("user");

    if (_user) {
      this.user = JSON.parse(_user);
    } else {
      this.user = null;
    }

    this.currentTab = this.navTabs[0].name;

    await this.getDistricts();

    this.getNod();
  },
};
</script>